export enum FulfillmentClosingType {
  ManualClosing = "ManualClosing",
  AutomatedClosing = "AutomatedClosing"
}
